import { render, staticRenderFns } from "./AnimalHealth.vue?vue&type=template&id=3536a0de&"
import script from "./AnimalHealth.vue?vue&type=script&lang=js&"
export * from "./AnimalHealth.vue?vue&type=script&lang=js&"
import style0 from "./AnimalHealth.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports